<template>
    <div v-if="classData">
        <v-container class="global-margin pb-0 mb-0">
            <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
        </v-container>
        <v-container class="content-wrap mt-0 pt-0">
            <v-row class="w-100 flex-center mx-0">
                <v-col cols="12" md="8" class="flex-center flex-column">
                    <h1 class="display-2 w-100 mb-4">
                        <template v-if="classData.grade == 10">
                            Ostalo
                        </template>
                        <template v-else>
                            Predmeti - {{ classData.grade }}. Razred
                        </template>
                        <span v-if="classData.high_school === 1">SŠ</span>
                    </h1>
                    <template v-if="classData.grade != 10">
                        <p class="w-100 text-justify my-12">
                            Odaberite lekciju iz ponuđenih predmeta ovoga razreda.
                        </p>
                        <div class="my-alert w-100 py-4 px-3 mb-4 flex-between">
                            <div class="flex-center">
                                <v-icon color="teal" class="mr-2">query_builder</v-icon>
                                <p class="mb-0">Raspored nastave</p>
                            </div>
                            <v-btn rounded outlined color="teal" :to="'/raspored/' + classData.grade"
                                   class="moodle-btn text-capitalize">Pogledaj
                                raspored</v-btn>
                        </div>
                    </template>
                    <v-expansion-panels flat hover v-if="classData.courses.length > 0">
                        <template v-for="(item, key) in classData.courses" >
                            <v-expansion-panel v-if="item.lessons.length > 0" :key="key" class="mb-2">
                                <v-expansion-panel-header class="blue-text font-weight-medium py-7 text-uppercase">{{ item.title }}</v-expansion-panel-header>
                                <v-expansion-panel-content class="py-5">
                                    <div v-if="item.lessons.length > 0">
                                        <div v-for="(x, key) in item.lessons" :key="key" class="mb-4">
                                            <router-link  :to="'/lekcije/' + x.id" class="blue-text">
                                                {{ x.title }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <v-alert v-else text color="red" border="left" class="w-100 pl-7">
                                        Nema lekcija
                                    </v-alert>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </template>
                    </v-expansion-panels>
                    <v-alert v-else text color="red" border="left" class="w-100 pl-7">
                        Za ovaj razred nije dostupan pregled predmeta.
                    </v-alert>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "Predmeti",
        data() {
            return {
                type: this.$route.params.type,
                classData: null,
                breadcrumbs: [
                    {
                        text: 'Naslovnica',
                        disabled: false,
                        to: '/'
                    },
                    {
                        text: 'Lekcije',
                        disabled: false,
                        to: '/lekcije'
                    },
                    {
                        text: '',
                        disabled: true,
                    },
                ],
            }
        },
        mounted (){
            this.$store.dispatch('getGrades');
            if (this.classID)
                this.getClassData();
        },
        computed: {
            classID() {
                if (this.type == 'osnovna') {
                    return this.$store.getters.getPrimarySchoolId(this.$route.params.grade)
                } else if (this.type == 'srednja') {
                    return this.$store.getters.getHighSchoolId(this.$route.params.grade)
                }
            }
        },
        methods: {
            getClassData() {
                skoleApi.get("razredi/" + this.classID).then(response => {
                    if(response.status == 200) {
                        this.classData = response.data;
                    }
                    this.breadcrumbs.forEach(element => {
                        if (element.disabled) {
                            if (this.classData.grade == 10) {
                                element.text = `Ostalo`
                            } else {
                                element.text = `Predmeti - ${this.classData.grade}. Razred`
                            }
                        }
                    });
                }).catch(error => {
                    if(error.response.status === 404) {
                        this.$router.push('/404');
                    }
                })
            }
        },
        watch: {
            classID: function (newVal) {
                if (newVal) {
                    this.getClassData();
                }
            }
        }
    };
</script>
<style lang="scss">
    .predmeti {
        margin-top: 180px;
    }
    @media(max-width: 768px) {
        .predmeti {
            margin-top: 120px !important;
        }
    }
    .moodle-btn {
        letter-spacing: 0 !important;
        border-radius: 30px;
    }
</style>
